import { render, staticRenderFns } from "./fileBlank.vue?vue&type=template&id=f3a6801e&scoped=true"
import script from "./fileBlank.vue?vue&type=script&lang=js"
export * from "./fileBlank.vue?vue&type=script&lang=js"
import style0 from "./fileBlank.vue?vue&type=style&index=0&id=f3a6801e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a6801e",
  null
  
)

export default component.exports